var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { attrs: { id: "test123" } },
    [
      _c(
        "v-dialog",
        { attrs: { "max-width": "500px", persistent: "", value: true } },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.$t("travelService.orderAnotherService")))
                ])
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.formValid,
                        callback: function($$v) {
                          _vm.formValid = $$v
                        },
                        expression: "formValid"
                      }
                    },
                    [
                      _c(
                        "fieldset",
                        { staticClass: "custom-fieldset" },
                        [
                          _c("order-user-select", {
                            attrs: {
                              value:
                                _vm.contextModel
                                  .travelServiceOrderItemPassengers[0]
                            },
                            on: {
                              "update:value": function($event) {
                                return _vm.$set(
                                  _vm.contextModel
                                    .travelServiceOrderItemPassengers,
                                  0,
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("travelService.otherServiceType") + "*",
                          placeholder: _vm.$t(
                            "travelService.otherServiceTypeExamples"
                          ),
                          rules: [
                            function(v) {
                              return (
                                (v != null && v.length > 0) ||
                                _vm.$t("global.error.required")
                              )
                            }
                          ]
                        },
                        model: {
                          value: _vm.contextModel.params,
                          callback: function($$v) {
                            _vm.$set(_vm.contextModel, "params", $$v)
                          },
                          expression: "contextModel.params"
                        }
                      }),
                      _c("cost-centre-select", {
                        attrs: { value: _vm.contextModel.cost_centre },
                        on: {
                          "update:value": function($event) {
                            return _vm.$set(
                              _vm.contextModel,
                              "cost_centre",
                              $event
                            )
                          }
                        }
                      }),
                      _c("v-text-field", {
                        attrs: { label: _vm.$t("global.comment") },
                        model: {
                          value: _vm.contextModel.comment,
                          callback: function($$v) {
                            _vm.$set(_vm.contextModel, "comment", $$v)
                          },
                          expression: "contextModel.comment"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.cancel($event)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: !_vm.formValid,
                        color: "blue darken-1",
                        text: ""
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.save($event)
                        }
                      }
                    },
                    [_vm._v("Ok")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }